module.exports = __webpack_public_path__ + "img/xwzx.5ddaa10c.png";